<!-- /系统管理-仿真知识教学-专业设置-专业课程列表  -->
<template>
  <div style="margin-top: 12px">
  <!-- <div style="display: flex; align-items: center">
      <span>当前标签:</span>
      <ul class="topUrl">
        <li v-for="(item, index) in labelList" :key="index">
          {{ item.label_name }}
          <i
            v-if="isShow"
            class="el-icon-circle-close"
            @click="delLabel(item)"
          ></i>
          <i
            v-if="isShow"
            class="el-icon-back move"
            @click="moveLabel(item, index)"
            >移动</i
          >
        </li>
      </ul>
    </div>
    <div style="float: right">
      <el-button type="success" @click="addLabelBtn">新增</el-button>
      <el-button type="success" @click="isShow = true">编辑</el-button>
        </div> -->
    <div>
      <el-table v-loading="loading" max-height="630" :data="dataList" border style="width: 100%">
        <!-- <el-table-column type="selection" align="center" fixed :selectable="checkSelectable"> </el-table-column> -->
        <el-table-column align="center" fixed prop="id" label="课程ID" min-width="80">
        </el-table-column>
        <el-table-column align="center" prop="name" label="课程名称" min-width="120">
        </el-table-column>
      <!-- <el-table-column align="center" label="课程标签" min-width="120">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.label_id"
              placeholder="请选择"
              @change="labelChange(scope.row)"
            >
              <el-option
                v-for="item in labelList"
                :key="item.id"
                :label="item.label_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>
            </el-table-column> -->
        <el-table-column align="center" prop="course_type" label="课程类型" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.course_type==1?'平台课程':'自建课程' }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="account_name" label="作者" min-width="120">
        </el-table-column>
      <!-- <el-table-column
          align="center"
          prop="create_time"
          label="创建时间"
          min-width="100"
        >
            </el-table-column> -->
        <el-table-column align="center" label="是否显示" min-width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.is_bind" :disabled="scope.row.is_disabled" active-color="#13ce66" :active-value="1" :inactive-value="0"
              @change="(e)=>{
                awitchChange(scope.row,e)
              }">
            </el-switch>
          </template>
        </el-table-column>
      <!-- <el-table-column align="center" label="操作" min-width="100">
          <template slot-scope="scope" >
            <div style="color: #67C23A">
              <el-button type="warning" icon="el-icon-top" size="mini" circle
                         @click.stop="moveClick(1,scope.$index,dataList)" v-show="scope.$index!=0"></el-button>
              <el-button type="warning" icon="el-icon-bottom" size="mini" circle
                         @click.stop="moveClick(2,scope.$index,dataList)"
                         v-show="scope.$index!=dataList.length-1"></el-button>
            </div>

          </template>
            </el-table-column> -->
      </el-table>
    </div>
  <!-- <div>
      <el-dialog
        title="添加标签"
        :visible.sync="dialogVisibleAddLabel"
        width="30%"
      >
        <el-select v-model="addLabelName" placeholder="请选择">
          <el-option
            v-for="item in allLabelList"
            :key="item.id"
            :label="item.label_name"
            :value="item.label_name"
            :disabled="item.disabled"
          >
          </el-option>
        </el-select>
        <el-button type="success" @click="addLabel">添加</el-button>
      </el-dialog>
        </div> -->
  </div>
</template>

<script>
import {
  ConfigMajorCourseList,
  ConfigMajorLabelList,
  ConfigMajorLabelDelete,
  ConfigMajorLabelSort,
  ConfigMajorLabelAdd,
  ConfigMajorCourseHide,
  ConfigMajorCourseLabelEdit,

  config_organization_course_get_list,
  organization_course_config_relation_add,
  organization_course_config_relation_delete
} from "../../../assets/js/network/network";
import UtilityTime from "@/assets/js/utility/UtilityTime";
export default {
  name: "ConfigMajorList",
  props: {
    disposeData: Object,
    config_item: Object,
  },
  data() {
    return {
      addLabelName: "",
      dialogVisibleAddLabel: false,
      allLabelList: [],
      loading: false,
      isShow: false,
      isDel: false,
      isMove: false,
      dataList: [],
      labelList: [],
      a: [],
    };
  },
  mounted() {
    this.getList(); //获取当前标签列表
  },
  methods: {
    moveClick(type, index, v) {
      // console.log(type,index,v)
      let value_array = []
      if (type == 1) {
        //上移
        value_array = [{
          course_id: v[index].course_id,
          sort: v[index - 1].sort
        },
        {
          course_id: v[index - 1].course_id,
          sort: v[index].sort
        }
        ]
      } else {
        //下移
        value_array = [{
          course_id: v[index].course_id,
          sort: v[index + 1].sort
        },
        {
          course_id: v[index + 1].course_id,
          sort: v[index].sort
        }
        ]
      }
      let data = {
        value_array,
        config_id: this.seeId
      }
      this.$post(this.$api.configCourseSorts, data).then(res => {
        if (res.code == 0) {
          this.getLabelList()
        }
      })
    },
    //获取标签列表
    getLabelList() {
      this.getList(); //获取专业课程列表
      let data = {
        config_id: this.seeId,
      };
      ConfigMajorLabelList(data).then((res) => {
        if (res.code == 0) {
          this.labelList = res.ret;
          this.a = [];
          this.labelList.map((it) => {
            this.a.push(it.id);
          });

        }
      });
    },

    //获取专业课程列表
    getList() {
      let data = {
        organization_id: this.disposeData.organization_id,
        config_id:this.config_item.id
      };
      config_organization_course_get_list(data).then((res) => {
        if (res.code == 0) {
          this.dataList = res.ret;
          this.dataList.map((item, index) => {
            item.create_time = UtilityTime.retun_formatDate11(item.create_time);
            if (this.a.indexOf(item.label_id) != -1) {
              item.label_id = item.label_id;
            } else {
              item.label_id = "";
            }
          });
        }
      });
    },
    //标签添加
    addLabelBtn() {
      //获取所有标签
      let data = {};
      ConfigMajorLabelList(data).then((res) => {
        if (res.code == 0) {
          this.allLabelList = res.ret;
          this.allLabelList.map((item) => {
            this.labelList.map((it) => {
              if (item.id == it.id || item.label_name == it.label_name) {
                item.disabled = true;
              }
            });
          });
        }
      });
      this.dialogVisibleAddLabel = true;
    },
    addLabel() {
      console.log(this.addLabelName);
      let data = {
        config_id: this.seeId,
        value_array: [
          {
            label_name: this.addLabelName,
            sort:
              this.labelList.length > 0
                ? this.labelList[this.labelList.length - 1].sort + 1
                : 1,
          },
        ],
      };
      if (this.addLabelName) {
        ConfigMajorLabelAdd(data).then((res) => {
          if (res.code == 0) {
            this.$message.success("添加成功");
            this.addLabelName = "";
            this.dialogVisibleAddLabel = false;
            this.getLabelList(); //获取标签列表
          }
        });
      } else {
        this.$message.warning("请选择");
      }
    },
    //标签移动
    moveLabel(item, index) {
      let data = {
        value_array: [],
      };
      if (index != 0) {
        data.value_array.push(
          {
            id: item.id,
            sort: this.labelList[index - 1].sort,
          },
          {
            id: this.labelList[index - 1].id,
            sort: this.labelList[index].sort,
          }
        );
      } else {
        this.labelList.map((it) => {
          data.value_array.push({
            id: it.id,
            sort: it.sort - 1,
          });
        });
        // this.labelList.map((it,in)=>{
        //       data.value_array.push({
        //          id: it.id,
        //          sort:it.sort-1
        //       })
        //   })
        console.log(data.value_array);
        data.value_array[0].sort =
          data.value_array[data.value_array.length - 1].sort + 1;
      }
      ConfigMajorLabelSort(data).then((res) => {
        if (res.code == 0) {
          this.getLabelList(); //获取当前标签列表
          this.$message.success("修改排序成功");
        }
      });
    },
    //标签删除
    delLabel(v) {
      console.log(v);
      let data = {
        config_id: this.seeId,
        value_array: [{ id: v.id }],
      };
      ConfigMajorLabelDelete(data).then((res) => {
        if (res.code == 0) {
          this.$message.success("删除成功");
          this.getLabelList(); //获取标签列表
        }
      });
    },
    // 是否显示
    awitchChange(v,e) {
      console.log(v,e);
      if (v.is_bind == 1) {
        let data = {
          course_id: v.id,
          config_id: this.config_item.id, //专业自增ID
          course_type: v.course_type
        };
        organization_course_config_relation_add(data).then((res) => {
          if (res.code == 0) {
            this.getList(); //获取当前标签列表
            this.$message.success("修改成功");
          }
        });
      } else {


          let data = {
            course_id: v.id,
            config_id: this.config_item.id, //专业自增ID
            course_type: v.course_type
          };
          organization_course_config_relation_delete(data).then((res) => {
            if (res.code == 0) {
              this.getList(); //获取当前标签列表
              this.$message.success("修改成功");
            }
          });

      }
    },
    // 标签选择
    labelChange(v) {
      console.log(v);
      let data = {
        course_id: v.course_id,
        config_id: this.seeIdZZ,
        label_id: v.label_id,
      };
      ConfigMajorCourseLabelEdit(data).then((res) => {
        if (res.code == 0) {
          this.$message.success("标签修改成功");
        }
      });
    },
  },
};
</script>

<style scoped>
.topUrl {
  display: flex;
  flex-wrap: wrap;
}

.topUrl li {
  font-size: 14px;
  position: relative;
  padding: 5px 10px;
  border: 1px solid #000;
  margin: 0 0 0 20px;
}

.topUrl li .move {
  opacity: 0.5;
  background: #ccc;
  /* width:20px; */
  /* padding: 2px 5px; */
  font-size: 12px;
  /* background: #fff; */
  position: absolute;
  top: -12px;
  left: 0px;
}

.topUrl li i {
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
}
</style>
